<template>
    <div class="home-link-nav">
        <div class="container">
            <ul class="link">
                <li>
                    <router-link :class="{active:selectNav==='index'}" to="/" href="">首页</router-link>
                </li>
                <li>
                    <router-link :class="{active:selectNav==='about'}" to="/about" href="">关于我们</router-link>
                </li>
                <li>
                    <router-link :class="{active:selectNav==='welfare'}" to="/welfare" href="">福利发放</router-link>
                </li>
                <li>
                    <router-link :class="{active:selectNav==='gift'}" to="/gift" href="">商务礼赠</router-link>
                </li>
            </ul>
            <div class="register">
                <a href="http://www.fufentong.com/user/apply.html" class="registerBtn">免费申请试用</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "home-link-nav",
        data() {
            return {}
        },
        computed: {
            selectNav() {
                return this.$route.name
            }
        }
    }
</script>

<style scoped lang="stylus">
    .home-link-nav
        width 100%
        min-width 1200px
        height 70px
        line-height 70px
        background-color rgba(0, 0, 0, 0.3)
        position absolute
        top 60px
        z-index 1
        border-bottom 1px solid #8d8888
        .link
            position relative
            display inline-block
            li
                display inline-block
                margin-right 40px
                a
                    min-width 40px
                    height 70px
                    text-align center
                    display block
                    font-size 14px
                    font-weight bold
                    color white
                    box-sizing border-box
                    &.active, &:hover
                        transition 0.3s
                        color #0089ff
                        border-bottom #0089ff solid 3px
                        box-sizing border-box
        .register
            position absolute
            right 0
            top 0
            .registerBtn
                display inline-block
                width 140px
                height 40px
                line-height 40px
                text-align center
                vertical-align middle
                border-radius 20px
                color white
                background-color #007ae6
                &:hover
                    background-color #0089ff
</style>